export default __webpack_public_path__ + "static/media/icon-cart.5e1893a6.svg";